import React from 'react';
import { styled } from "@mui/material/styles";
import MuiToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    background: "var(--text-color) !important",
    color: "var(--bg-color) !important",
    fontWeight: "bold !important"
  }
});

function PitchButtons(props) {

  return (
    <ToggleButtonGroup
      defaultValue={props.value}
      value={props.value}
      exclusive
      onChange={props.onPitchChange}
      aria-label="text alignment"
      className="muvika-pitch-buttons-group"
    >
      <ToggleButton className="muvika-toggle-button" value={-3}>
        -3
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={-2}>
        -2
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={-1}>
        -1
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={0}>
        0
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={1}>
        +1
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={2}>
        +2
      </ToggleButton>
      <ToggleButton className="muvika-toggle-button" value={3}>
        +3
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default PitchButtons;